import { render, staticRenderFns } from "./FormPartnershipTypeLocale.vue?vue&type=template&id=dede1a00&scoped=true&"
import script from "./FormPartnershipTypeLocale.vue?vue&type=script&lang=js&"
export * from "./FormPartnershipTypeLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dede1a00",
  null
  
)

export default component.exports